import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/MultiPayChange';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得自行繳費條款說明
export function getAgreeTermsMultiPayChange() {
    return get(`${url}/getAgreeTerms`);
}

// 自行繳費條款說明：同意送出
export function postAgreeMultiPayChange() {
    return post(`${url}/agree`);
}

// 取得可自行繳費保單
export function getInfoMultiPayChange() {
    return get(`${url}/info`);
}

// 送出選擇自行繳費保單
export function submitMultiPayChange(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
